var React = require('react');

function Organisations (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M10 7.546v4.909M2.636 12.454V10h14.727v2.454M10 4.273c.904 0 1.636-.733 1.636-1.637C11.636 1.733 10.905 1 10 1c-.904 0-1.636.733-1.636 1.636 0 .904.732 1.637 1.636 1.637zM2.636 19c.904 0 1.637-.733 1.637-1.637 0-.903-.733-1.636-1.637-1.636-.903 0-1.636.733-1.636 1.636C1 18.267 1.733 19 2.636 19zM10 19c.904 0 1.636-.733 1.636-1.637 0-.903-.732-1.636-1.636-1.636-.904 0-1.636.733-1.636 1.636C8.364 18.267 9.096 19 10 19zM17.363 19c.904 0 1.637-.733 1.637-1.637 0-.903-.733-1.636-1.637-1.636-.903 0-1.636.733-1.636 1.636 0 .904.733 1.637 1.636 1.637z"}));
}

Organisations.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 20 20","stroke":"#737680"};

module.exports = Organisations;

Organisations.default = Organisations;
